import _isNil from "lodash/isNil";
import { locale as getLocale } from '@signavio/i18n';
import { DateTimeLocal, stickWidgetToInput } from '@signavio/ui/core';
import { defaultStyle, useStyles } from '@signavio/ui';
import { utils } from '../../styles';
import DatePicker from './DatePicker';
import { convertDateTime } from './higher-order';
import { validateDate } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
function DateTimeInput({
  value,
  locale = getLocale().replace('_', '-'),
  onChange,
  ...rest
}) {
  const styles = useStyles(dateTimeInputStyles, {});
  return /*#__PURE__*/_jsx(DateTimeLocal, {
    ...rest,
    style: styles,
    culture: locale,
    value: getValueWithoutTimezone(value),
    onChange: newValue => {
      if (!validateDate(newValue)) {
        return;
      }
      onChange(addTimezone(newValue));
    }
  });
}
const dateTimeInputStyles = theme => ({
  width: '100%',
  ...utils.input(theme)
});
const getValueWithoutTimezone = value => {
  const validatedDate = validateDate(value);
  if (_isNil(validatedDate)) {
    return null;
  }
  return validatedDate.toISOString();
};
const addTimezone = value => value && new Date(value).toISOString();
const StyledDatePickerConvertedDateTime = defaultStyle(({
  color
}) => ({
  ...utils.border('1px', 'solid', color.mono.lighter),
  ...utils.boxShadow()
}))(DatePicker);
const DatePickerConvertedDateTime = convertDateTime(StyledDatePickerConvertedDateTime);
export default stickWidgetToInput(DatePickerConvertedDateTime, DateTimeInput);